async function failTask (taskId) {
  if (!this.dbClient) return
  return this.dbClient.tasks.update(taskId, { complete: false, serverId: null, touched: null })
}

export default failTask